import type { ApplicationSettingsTabId } from '../store/application-settings-tab-id';
import type { SettingsTabId } from '../store/proxy-store';
import { useLayoutStore } from '../store/layoutStore';
import { TAB_SECTION_SCOPES, type TabSectionScope } from '../store/tabSections';

function setTabSectionOnActiveTab({
  scope,
  sectionId,
}: {
  scope: TabSectionScope;
  sectionId: string;
}): void {
  const activeTabId = useLayoutStore.getState().activeMainContentTabId;

  if (!activeTabId) return;
  useLayoutStore
    .getState()
    .setTabSection({ scope, tabId: activeTabId, sectionId });
}

export function setApplicationSettingsSubTabOnActiveTab(
  subTab: ApplicationSettingsTabId,
): void {
  setTabSectionOnActiveTab({
    scope: TAB_SECTION_SCOPES.applicationSettings,
    sectionId: subTab,
  });
}

export function setProxySettingsSubTabOnActiveTab(subTab: SettingsTabId): void {
  setTabSectionOnActiveTab({
    scope: TAB_SECTION_SCOPES.proxySettings,
    sectionId: subTab,
  });
}
